import { Text, Texture } from "pixi.js";
import { UserProfileResourcePackage } from "../../../userprofile/resources/UserProfileResourcePackage";
import { LatestNewsResourcePackage } from "../../resources/LatestNewsResourcePackage";
import { INewsItemOptions } from "./NewsItem";
import { NewsItemWithAvatar } from "./NewsItemWithAvatar";
import { CurrencyType, NewsCurrencyComponent } from "../NewsCurrencyComponent";
import { NewsTextStyle } from "../styles/NewsTextStyle";

export class NewsItemMintReward extends NewsItemWithAvatar {
    private static readonly YOUVE_EARNED_TEXT = "YOU'VE EARNED";
    private static readonly THANK_YOU_TEXT = 'THANK YOU FOR YOUR PARTICIPANT\nIN OUR PIGGY CLUB MINT';

    private youEarnedText: Text;
    private currencyComponent: NewsCurrencyComponent;
    private thanksYouText: Text;

    public constructor(
        id: string,
        newsResources: LatestNewsResourcePackage,
        userProfileResources: UserProfileResourcePackage,
        options: NewsItemMintRewardOptions
    ) {
        super(
            id,
            newsResources,
            userProfileResources,
            newsResources.assets_views_latest_news_news_tooltip_blue_png,
            newsResources.assets_views_latest_news_news_token_upgrade_png,
            options.playerAvatarTexture
        );
        this.build(options);
        this.layout();
    }

    private build(options: NewsItemMintRewardOptions): void {
        this.youEarnedText = new Text(NewsItemMintReward.YOUVE_EARNED_TEXT, new NewsTextStyle());
        this.currencyComponent = new NewsCurrencyComponent(this.newsResources, options.rewardInTokens, CurrencyType.TOKEN);
        this.thanksYouText = new Text(NewsItemMintReward.THANK_YOU_TEXT, new NewsTextStyle());
        this.thanksYouText.style.lineHeight = 37;
        this.avatar.updateTexture(options.playerAvatarTexture);

        this.addChild(this.youEarnedText, this.currencyComponent, this.thanksYouText);
    }

    private layout(): void {
        this.youEarnedText.position.set(411, 67);
        this.currencyComponent.position.set(this.youEarnedText.position.x + this.youEarnedText.width + 5, 67);
        this.thanksYouText.position.set(411, 107);
    }
}

export class NewsItemMintRewardOptions implements INewsItemOptions {
    public readonly playerAvatarTexture: Texture;
    public readonly rewardInTokens: number;

    public constructor(playerAvatarTexture: Texture, rewardInTokens: number) {
        this.playerAvatarTexture = playerAvatarTexture;
        this.rewardInTokens = rewardInTokens;
    }
}
